import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';
// Swiper.use([EffectFade, Autoplay]);

function dm_c05() {
    if ($('.c05-swiper').length) {
        $('.c05-swiper').each(function () {
            const $wrapper = $(this);
            if (!$wrapper.hasClass('swiper')) {
                $wrapper.addClass('swiper');
                const $slidesWrapper = $('<div class="swiper-wrapper"></div>');
                $wrapper.find('img').each(function () {
                    const $img = $(this);
                    const $slide = $('<div class="swiper-slide"></div>');
                    $img.appendTo($slide);
                    $slidesWrapper.append($slide);
                });
                $wrapper.append($slidesWrapper);
            }

            new Swiper($wrapper[0], {
                modules: [EffectFade, Autoplay],
                effect: 'fade',
                fadeEffect: { crossFade: true },
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                loop: true,
                speed: 800,
            });
        });
    }
}

export { dm_c05 };
